import React from 'react';
import './PageLoader.css';

export default function PageLoader({
    title = 'Loading',
    message = 'Please wait while we fetch data.',
}) {
    return (
        <div className="pg-loader">
            <div className="pg-spinner" />
            <h4>{title}</h4>
            {message ? <p>{message}</p> : null}
        </div>
    );
}
